module.exports = __webpack_public_path__ + "static/media/typhoons.6ce2f70a.png";